import React, { useState } from 'react'
import {
  // Hr,
  Eth,
  Days,
  Time,
  Coin,
  Image,
  Title,
  Author,
  Option,
  Details,
  Profile,
  Subtitle,
  Toggler ,
  Countdown,
  Container,
  AuthorName,
  ImageContainer,
} from './Card.styles'

// import { GlobalStyle } from "../Theme/GlobalStyle";
import { ThemeProvider } from "styled-components"
import {IoEyeSharp} from "react-icons/io5"
import { FiSun, FiMoon } from "react-icons/fi";
import { lightTheme, darkTheme, GlobalStyles} from '../theme/Theme'




function Card ()  {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseHover = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [theme, setTheme] = useState(true);
  const icon = theme === "light" ? <FiMoon size={26} /> : <FiSun size={26} />
  const toggleTheme = () => { theme === "light" ? setTheme("dark") : setTheme("light") }

  return (
    <Container >
        <ImageContainer  onMouseOver={handleMouseHover} onMouseOut={handleMouseOut}>
        {isHovering ?<img src='../images/icon-view.svg'   className="imgIcon"/>: null}
        <Image src='../images/image-equilibrium.jpg' alt='image eqilibrium'/>
        </ImageContainer>
        

        <Details>
      <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles/>
          <Title>Equilibrium #3429</Title>
          <Subtitle>Our equilibrium collection promotes balance and calm.</Subtitle>
            
          <Option>
            <Coin>
              <Eth src='../images/icon-ethereum.svg'  alt=''/>
              <span>0.041ETH</span>
            </Coin>

            <Days>
              <Time src='../images/icon-clock.svg'  alt=''/>
              <Countdown>3 days left</Countdown>
            </Days>
          </Option>

          {/* <Hr></Hr> */}

          <Author>
          
            <Profile src='../images/image-avatar.png'  alt=""/>
            <AuthorName>Creation of <span>Jules Wyvern</span></AuthorName>
          </Author>

        
          <Toggler onClick={toggleTheme}>{icon}</Toggler>
          
    </ThemeProvider>
        </Details>
    </Container>
  )
}

export default Card;